import { ActionTypes, GlobalModals } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { ForbiddenError, UnauthorisedError } from '../errors/API';
import ModalActions from '../actions/ModalActions';

export const logoutUser = error => {
    AppDispatcher.dispatch({
        actionType: ActionTypes.AUTH_ERROR,
        error
    });

    AppDispatcher.dispatch({
        actionType: ActionTypes.LOGGED_OUT
    });

    AppDispatcher.dispatch({
        actionType: ActionTypes.LOADING_STOPPED
    });

    ModalActions.open(GlobalModals.LOGGED_OUT, {
        onClose: () => ModalActions.close(GlobalModals.LOGGED_OUT)
    });
};

export function handleUnauthorisedError(error) {
    if (error instanceof UnauthorisedError) {
        logoutUser(error);
    } else {
        throw error;
    }
}

export function handleForbiddenError(error) {
    if (error instanceof ForbiddenError) {
        logoutUser(error);
    } else {
        throw error;
    }
}

export function checkForbidden (target, name, descriptor) {
    const original = descriptor.value;

    descriptor.value = function () {
        return original
                    .apply(this, arguments)
                    .catch(handleForbiddenError);
    };
    descriptor.value.__DECORATORS = ['checkForbidden'].concat(original.__DECORATORS || []); // for unit tests
    return descriptor;
}



// WEBPACK FOOTER //
// ./src/decorators/Customer.js